import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { VisualNavigation as VisualNavigationComponent } from '@thd-olt-component-react/visual-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function VisualNavigation({ id, title }) {
  return (
    <ErrorBoundary name="visual-navigation">
      <QueryProvider key={id} cacheKey={id}>
        <div
          id={`visual-navigation-php-${id}`}
          className="vis-nav-wrapper sui-h-full"
        >
          {title && (
            <div className="sui-my-4">
              <Typography
                variant="h2"
                height="snug"
                color="primary"
                uppercase
              >
                {title}
              </Typography>
            </div>
          )}
          <VisualNavigationComponent
            componentId={id}
            componentClass="VisualNavigation"
          />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}

VisualNavigation.propTypes = {
  id: string,
  title: string,
};

VisualNavigation.defaultProps = {
  id: undefined,
  title: undefined,
};
